import { FAQ, FAQByLocale } from '../../../types/Faq';
import { Locale } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const filterFaqsByLocale = (faqs?: FAQ[], locale?: string) => {
  const filtered: FAQByLocale[] = [];

  faqs?.forEach((faq) => {
    switch (locale) {
      case Locale.JAPANESE:
        if (faq.questionJa && faq.answerJa) {
          filtered.push({
            id: faq.id,
            question: faq.questionJa,
            answer: faq.answerJa,
            updatedAt: faq.updatedAt,
          });
        }
        break;
      case Locale.CHINESE_SIMPLIFIED:
      case Locale.CHINESE_TRADITIONAL:
      case Locale.ENGLISH:
      case Locale.KOREAN:
      default:
        if (faq.questionEn && faq.answerEn) {
          filtered.push({
            id: faq.id,
            question: faq.questionEn,
            answer: faq.answerEn,
            updatedAt: faq.updatedAt,
          });
        }
        break;
    }
  });
  return filtered;
};
